import { makeStyles } from '@material-ui/core/styles';

import theme from '../MaterialUi/MaterialUi';

const useStyles = makeStyles({
	spacer: {
		marginTop: '4em',
	},
	productsTitle: {
		fontSize: theme.spacing(5),
		marginTop: '6rem',
		marginBottom: '2rem',
		color: '#494949',
	},
	specialitiesTitle: {
		fontSize: theme.spacing(5),
		marginTop: '2rem',
		marginBottom: '2rem',
		color: '#494949',
	},
	titleBackgroundColor: {
		borderRadius: '10px',
		width: '20rem',
		backgroundColor: theme.palette.secondary.light,
	},
});

export default useStyles;
